"use client";

import { clarifications, measured } from "./checkrideV6DemoData";

/**
 * A real candidate asks what the question meant. Showing this honestly means showing
 * the two cases where it DID cost him, which is why the counts are rendered from the
 * data rather than written into the copy.
 */
export default function V6Clarification() {
  const free = clarifications.filter((c) => c.free);
  const charged = clarifications.filter((c) => !c.free);
  const pick = free.slice(0, 3);

  return (
    <section id="clarify" className="py-24 md:py-32 px-6 bg-white border-t border-hairline/60">
      <div className="max-w-3xl mx-auto">
        <span className="text-[11px] font-semibold tracking-wider uppercase text-accent">
          When the candidate pushes back
        </span>
        <h2 className="mt-3 text-3xl md:text-4xl font-bold tracking-[-0.02em] text-ink">
          Asking what a question means is not a wrong answer
        </h2>
        <p className="mt-4 text-ink-soft leading-relaxed">
          A real applicant says &ldquo;do you mean the regulation, or what I&rsquo;d
          actually plan?&rdquo; A bad simulator marks that as a miss. This one rewords the
          question and charges him nothing &mdash; it happened{" "}
          <strong className="text-ink font-semibold">{measured.clarifications} times</strong>{" "}
          across the three exams, and cost him nothing on{" "}
          <strong className="text-ink font-semibold">{measured.clarificationsFree}</strong>{" "}
          of them.
        </p>

        <div className="mt-10 space-y-6">
          {pick.map((c, i) => (
            <div key={i} className="rounded-2xl border border-hairline overflow-hidden lift">
              <div className="px-5 py-4 bg-ground-alt">
                <div className="text-[10px] font-bold uppercase tracking-wider text-ink-faint mb-1.5">
                  Candidate
                </div>
                <p className="text-[15px] leading-relaxed text-ink-soft whitespace-pre-wrap">{c.asked}</p>
              </div>
              <div className="px-5 py-4 border-t border-hairline">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-accent">
                    Examiner
                  </span>
                  <span className="px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 text-[10px] font-semibold tracking-wide">
                    cost him nothing
                  </span>
                </div>
                <p className="text-[15px] leading-relaxed text-ink whitespace-pre-wrap">{c.examinerReplied}</p>
              </div>
            </div>
          ))}
        </div>

        {charged.length > 0 && (
          <div className="mt-10 rounded-2xl border border-amber-200 bg-amber-50/50 px-5 py-4">
            <p className="text-sm text-amber-900 leading-relaxed">
              <strong className="font-semibold">
                And the {charged.length === 1 ? "one that did" : `${charged.length} that did`} cost him.
              </strong>{" "}
              There is a limit: two free rewordings per topic. Past that, the examiner
              presses and it counts &mdash; otherwise a candidate could keep a question
              open forever. {charged.length === 1 ? "That case is" : "Those cases are"} in
              the record too, which is why the number above reads{" "}
              {measured.clarificationsFree} of {measured.clarifications} rather than
              &ldquo;always&rdquo;.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
